export default function dropdown() {
    return {
        open: false,
        activeIndex: -1,

        get expandedAttr() {
            return String(this.open);
        },

        toggle() {
            this.open = !this.open;
            if (this.open) {
                this.activeIndex = -1;
            }
        },

        close() {
            this.open = false;
            this.activeIndex = -1;
        },

        focusNext() {
            const items = this.getItems();
            if (items.length === 0) return;
            this.activeIndex = (this.activeIndex + 1) % items.length;
            items[this.activeIndex].focus();
        },

        focusPrev() {
            const items = this.getItems();
            if (items.length === 0) return;
            this.activeIndex =
                (this.activeIndex - 1 + items.length) % items.length;
            items[this.activeIndex].focus();
        },

        selectActive() {
            const items = this.getItems();
            if (this.activeIndex >= 0 && items[this.activeIndex]) {
                items[this.activeIndex].click();
            }
            this.close();
        },

        getItems() {
            return this.$refs.menu
                ? Array.from(
                      this.$refs.menu.querySelectorAll('[role="menuitem"]'),
                  )
                : [];
        },

        handleKeydown(event) {
            if (!this.open) return;

            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    this.focusNext();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    this.focusPrev();
                    break;
                case 'Enter':
                case ' ':
                    event.preventDefault();
                    this.selectActive();
                    break;
                case 'Escape':
                    event.preventDefault();
                    this.close();
                    this.$refs.trigger.focus();
                    break;
            }
        },

        init() {},
        destroy() {},
    };
}
